<script>
import { Row, Col, Field } from 'vant'
import ImageNameLinkSelector from '@/components/org/ImageNameLinkSelector'
import PickerSelector from '@/components/org/PickerSelector'
import Match from '@/tbs/model/to/Match'

const match = new Match

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
    name: 'match-name-input',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-row': Row,
        'van-col': Col,
        'van-field': Field,
        'image-name-link-selector': ImageNameLinkSelector,
        'picker-selector': PickerSelector,
    },

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
    props: {
        matchBrandName:String,
        matchBrandLogoUrl: String,
        matchYear:String,
        matchSession:String,
        matchName:String,
        disabled:Boolean,
	},

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
    emits: ['click-link', 'change-data'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            year: null,
            session: null,
            name: null,
            isNameInputChanged: false,
            isFieldDisabled: false
        }
    },

    computed: {
        yearOptions() {
            return this.getYearOptions()
        },
        yearIndex() {
            const years = this.getYearOptions()
            if (this.matchYear) {
                for (let i = 0; i < years.length; i++) {
                    let year = years[i]
                    if (this.matchYear == year) {
                        return i
                    }
                }
            }
            return Math.floor(years.length/2)
        },
        matchYearField: {
            get: function() {
                // console.log('matchYearField getter', typeof(this.year), typeof(this.matchYear))
                return this.year ? this.year : this.matchYear
            },
            set: function(value) {
                // console.log('matchYearField setter', value)
                this.year = value
            }
        },
        matchSessionField: {
            get: function() {
                return this.session ? this.session : this.matchSession
            },
            set: function(value) {
                this.session = value
            }
        },
        matchNameField: {
            get: function() {
                console.log('@getter matchNameField |', this.name, '|',this.calcAutoFilledMatchName())
                // @special avoid to fill the calculated match name while '' after clearable triggered
                // allow the '' as the valid value for the match name for a while
                return (this.name != null) ? this.name : this.calcAutoFilledMatchName()
            },
            set: function(value) {
                this.name = value
                console.log('setter matchNameField', value)
                this.dispatchDataChangeEvent()
            }
        },
        matchBrandLabel() {
            return match.localeProp('match-brand-label')
        },
        matchYearLabel() {
            return match.localeProp('match-year-label')
        },
        matchSessionLabel() {
            return match.localeProp('match-session-label')
        },
        matchNameLabel() {
            return match.localeProp('match-name-label')
        },
        matchNamePrompt() {
            return match.localeProp('match-name-prompt')
        },
        isMatchBrandDisabled() {
            return this.disabled
        },
        isMatchYearDisabled() {
            return this.disabled || this.isFieldDisabled || !this.matchBrandName
        },
        isMatchSessionDisabled() {
            return this.disabled || this.isFieldDisabled || !this.matchBrandName
        },
        isMatchNameDisabled() {
            return this.disabled || !this.matchBrandName
        }
    },

    watch: {
        matchBrandName(value) {
            if (value) {
                console.log('@watch matchBrandName', value, this.name)
                const self = this
                setTimeout(function() {
                    console.log('@self.name', self.name)
                    if (!self.name) {
                        self.name = self.calcAutoFilledMatchName()
                        self.dispatchDataChangeEvent()
                    }
                }, 1000)
            }
        },
        matchName(value) {
            console.log('@watch matchName', value, this.name)
            if (value) {
                this.name = value
                this.onMatchNameFieldInput()
            }
            /*
            // avoid the auto filling match name while clear the input
            else {
                this.name = this.calcAutoFilledMatchName()
                this.onMatchBrandNameFieldInput()
                this.dispatchDataChangeEvent()
            }*/
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        getYearOptions() {
            var years = [];
            const currentTimeStamp = (new Date).getTime()
            const total = 5
            const oneYearTimestamp = 365 * 24 * 60 * 60 * 1000
            let timestamp = currentTimeStamp - Math.floor(total/2) * oneYearTimestamp
            for (let i = 0; i < total; i++) {
                const year = new Date(timestamp + i * oneYearTimestamp).getFullYear().toString()
                years.push({label: year, value: year})
            }
            return years
        },
        onMatchYearDataChange(data) {
            // console.log('onMatchYearDataChange', data)
            if (this.year != data.value) {
                this.year = data.value
                this.name = this.calcAutoFilledMatchName()
                this.dispatchDataChangeEvent()
            }
        },
        onMatchSessionFieldInput() {
            // console.log('onMatchSessionFieldInput')
            this.name = this.calcAutoFilledMatchName()
            this.dispatchDataChangeEvent()
        },
        onMatchNameFieldInput() {
            console.log('onMatchNameFieldInput')
            console.log('@', this.calcAutoFilledMatchName(), this.name)
            if (this.calcAutoFilledMatchName() != this.name) {
                this.isNameInputChanged = true
                this.isFieldDisabled = true
            }
            else {
                this.isNameInputChanged = false
                this.isFieldDisabled = false
            }     
        },
        onMatchBrandNameFieldInput() {
            console.log('onMatchBrandNameFieldInput')
            this.isNameInputChanged = false
            this.isFieldDisabled = false
        },
        calcAutoFilledMatchName() {
            if (this.matchBrandName) {
                return match.localeProp('match-name-pattern', {
                    brand: this.matchBrandName,
                    year: (this.year ? this.year : this.matchYear),
                    session: (this.session ? this.session : this.matchSession)
                })
            }
            else {
                return ''
            }
        },
        dispatchDataChangeEvent() {
            this.$emit('change-data', {
                name: this.name,
                year: (this.year ? this.year : this.matchYear),
                session: (this.session ? this.session : this.matchSession)
            })
        }
    },
}
</script>

<template>
    <!-- component -->
    <div class="match-name-input">
        <image-name-link-selector
            :label="matchBrandLabel"
            :name="matchBrandName"
            :imageUrl="matchBrandLogoUrl"
            :disabled="isMatchBrandDisabled"
            @click-link="$emit('click-link')"
        />
        <van-row class="b-inner-margin">
            <van-col span="12">
                <picker-selector
                    :label="matchYearLabel"
                    :options="yearOptions"
                    :value="matchYearField"
                    :index="yearIndex"
                    :disabled="isMatchYearDisabled"
                    @change-data="onMatchYearDataChange"
                />
            </van-col>
            <van-col span="12">
                <van-field
                    v-model="matchSessionField"
                    :label="matchSessionLabel"
                    :disabled="isMatchSessionDisabled"
                    type="digit"
                    clearable
                    input-align="right"
                    maxlength="3"
                    @input="onMatchSessionFieldInput"
                />
            </van-col>
        </van-row>
        <div class="minor-text u-outer-padding">
            <span>{{ matchNameLabel }}</span>
            <span class="pull-right minor-color">{{ matchNamePrompt }}</span>
        </div>
        <van-field
            v-model="matchNameField"
            :disabled="isMatchNameDisabled"
            clearable
            type="textarea"
            rows="2"
            autosize
            maxlength="100" 
            show-word-limit
            @input="onMatchNameFieldInput"
        />
    </div>
</template>